import { createApp } from 'vue'
import App from './App.vue'
import router  from "./router/index";
import Antd from 'ant-design-vue'; // 引入 Ant Design Vue
import 'ant-design-vue/dist/antd.css'; // 引入样式文件
import { $setToken } from './utils/request';
import './assets/css/global.css'



 
//每次刷新时都会重新执行main.js所以为了避免设置的token在刷新时丢失，在这里进行特殊处理下
let token=localStorage.getItem('token');
if(token){
    $setToken(token);
}

const app = createApp(App);

app.use(router)

app.use(Antd); // 全局使用 Ant Design Vue 组件库


app.config.errorHandler = (err, vm, info) => {
    // 自定义错误处理逻辑（如打印到控制台、上报日志等）
    console.error('Vue 运行时错误:', err, info);
  };

app.mount('#app');